import {Injectable} from '@angular/core';
import {ApiService} from '@common-lib';
import {map} from 'rxjs/operators';

@Injectable()
export class UsersService {

    constructor(private api: ApiService) {
    }

    getList() {
        return this.api.get('/admin/users/').pipe(map(({result}) => result));
    }

    update(localeName: string, value) {
        return this.api.put('/admin/users', value).pipe(map(({result}) => result));
    }

    create(localeName: string, value) {
        return this.api.post('/admin/users', value).pipe(map(({result}) => result));
    }


    delete(user) {
        if (user) {
            return this.api.delete('/admin/users/' + user.id).pipe(map(response => response));
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/pages-services/users.service.ts